//
//
export const NAVBAR_HEIGHT = '80px'
export const SIDEBAR_WIDTH = '285px'
export const FILTER_CLEAR_BTN_WIDTH = 80
